(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoIbqDeleteController',VideoIbqDeleteController);

    VideoIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Video'];

    function VideoIbqDeleteController($uibModalInstance, entity, Video) {
        var vm = this;

        vm.video = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Video.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
